/* global gtag */

import React from "react";
import Checkmark from "../includes/svg/checkmark-icon";

const plans = [
    {
        name: "Basic",
        price: "$4,600",
        pricePer: "/mo",
       includes: [
        "White Labeled Service",
        "10 Hours Per Week",
        "1 Dedicated Team Member",
        "8% Discount on All other Services",
        "48 hour Team Member Placement",
        "Access to Client Portal",
        "Free PM Software Analysis"
       ],
       link: "https://app.usemotion.com/meet/PMG/meeting",
       buttonText: "Start Your Partnership",
       bestValue: false
    },
    {
        name: "Business",
        price: "$8,600",
        pricePer: "/mo",
        includes: [
            "White Labeled Service",
            "20 Hours Per Week",
            "Up to 2x Dedicated Team Members",
            "15% Discount on All other Services",
            "24 hour Team Member Placement",
            "Access to Client Portal",
            "Free PM Software Analysis"
        ],
        link: "https://app.usemotion.com/meet/PMG/meeting",
        buttonText: "Start Your Partnership",
        bestValue: true
    },
    {
        name: "Business Pro",
        price: "$12,500",
        pricePer: "/mo",
        includes: [
            "White Labeled Service",
            "30 Hours Per Week",
            "Up to 4x Dedicated Team Members",
            "17% Discount on All other Services",
            "24 hour Team Member Placement",
            "Access to Client Portal",
            "Free PM Software Analysis"
        ],
        link: "https://app.usemotion.com/meet/PMG/meeting",
       buttonText: "Start Your Partnership",
        bestValue: false
    },
    {
        name: "Per-Project Pricing",
        price: "Contact Sales",
        pricePer: "",
        includes: [
            "White Labeled Service",
            "Starting at $115/hr",
            "Up to 5x Dedicated Team Members",
            "20% Discount on All other Services",
            "Access To All PM Templates",
            "Access to Client Portal",
            "Free PM Software Analysis"
        ],
        link: "https://app.usemotion.com/meet/PMG/meeting",
        buttonText: "Start Your Partnership",
        bestValue: false
    }
]

const PricingTable = () => {
    return (
        <div className="flex flex-col gap-x-8 gap-y-16 lg:justify-center lg:flex-wrap xl:flex-nowrap lg:flex-row text-black container pb-24">
            {plans.map((plan, index) => (
                <div key={index} className={`bg-` + (plan.bestValue ? "primaryBrand text-white10" : "white border-borderPrimary border-solid border") + " p-6 rounded-3xl flex flex-col justify-start items-start gap-6 lg:basis-[46%] xl:basis-1/4 flex-initial relative"}>
                    <div className="w-full flex flex-col gap-6 justify-start text-left items-start">
                        <div className="flex flex-col gap-4 items-start">
                            <h2 className="text-2xl font-bold pointer-events-none">{plan.name}</h2>
                            <h3 className={(plan.pricePer === "" ? "md:text-4xl text-3xl" : "md:text-5xl text-4xl") + " font-bold pointer-events-none"}>
                                {plan.price}<span className="text-base">{plan.pricePer}</span>
                            </h3>
                        </div>
                        <div className={"h-[1px] w-4/5 mx-auto" + (plan.bestValue ? " bg-white10" : " bg-gradientBorder")}></div>
                        <ul className="flex flex-col gap-6 text-left">
                            {plan.includes.map((include, index) => (
                                <li key={index} className="flex flex-row gap-4 items-center">
                                    <div className={(plan.bestValue ? "bg-white" : "bg-grey45") + " w-6 h-6 rounded-full aspect-square flex justify-center items-center"}>
                                        <Checkmark color={plan.bestValue ? "#182553" : "white"} />
                                        </div>
                                    <p className={(plan.bestValue ? "text-white10" : "text-grey45") + " text-sm font-bold pointer-events-none"}>{include}</p>
                                </li>
                            ))}
                        </ul>
                        <a
                            href={plan.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="border-primaryBrand bg-white border border-solid hover:bg-primaryBrand w-full text-center p-3 rounded-lg group flex justify-center items-center relative overflow-hidden transition duration-300 ease-in-out cursor-pointer gap-2.5 hover:bg-btnHover text-primaryBrand hover:text-white"
                            onClick={() => {
                                window.dotq = window.dotq || [];
                                window.dotq.push({
                                    projectId: "10000",
                                    properties: {
                                        pixelId: "10204628",
                                        qstrings: {
                                            et: "custom",
                                            ea: `PMG_SIgnUpButton_${plan.name}`,
                                        },
                                    },
                                });

                                const gtag_report_conversion = (url) => {
                                    const callback = () => {
                                        console.log("Callback executed, but no redirect.");
                                    };
                                    gtag("event", "conversion", {
                                        send_to: "AW-11182330949/WjxnCKT7l70aEMWok9Qp",
                                        event_callback: callback,
                                    });
                                    return false;
                                };

                                gtag_report_conversion(plan.link);
                            }}
                        >
                            {plan.buttonText}
                        </a>
                    </div>
                    
                </div>
            ))}

            
        </div>
    );
};

export default PricingTable;